var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"page__logo",class:{
    'page__logo--inverted': _vm.invertedColors,
    'page__logo--large': _vm.largeLogo,
  },attrs:{"to":{ name: _vm.routeName }}},[_c('HdIcon',{attrs:{"src":_vm.homedayLogo,"width":_vm.largeLogo ? 46 : 32,"height":_vm.largeLogo ? 46 : 32}}),_c('div',{staticClass:"page__logo-text-wrapper"},[_c('span',{staticClass:"page__logo-appname"},[_vm._v(_vm._s(_vm.$t('GENERAL.APP_NAME')))]),_c('span',{staticClass:"page__logo-subtitle"},[_vm._v(_vm._s(_vm.$t('GENERAL.APP_NAME_SUBTITLE')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }